import { useIntl } from "react-intl";
import ErrorPage from "../ErrorPage";

/**
 * Global 404 page displayed when a route is not matched.
 *
 * Uses the shared ErrorPage component with the ISPM design-system primitives.
 * Registered as TanStack Router's `defaultNotFoundComponent`.
 */
function PageNotFound() {
  const intl = useIntl();

  return (
    <ErrorPage
      illustrationKind="Error"
      statusCode={intl.formatMessage({
        id: "J4PC9c",
        defaultMessage: "404",
        description: "404 page not found Error code",
      })}
      title={intl.formatMessage({
        id: "22tv7R",
        defaultMessage: "Page Not Found",
        description: "Title for the 404 page not found screen",
      })}
      description={intl.formatMessage({
        id: "zWmtJb",
        defaultMessage:
          "The page you are looking for has been removed or is temporarily unavailable.",
        description: "Description text on the 404 page not found screen",
      })}
      buttonLabel={intl.formatMessage({
        id: "HAzbdO",
        defaultMessage: "Back to Home",
        description: "Button label to navigate back to home from 404 page",
      })}
      testId="PageNotFound"
    />
  );
}

export default PageNotFound;
